export const OPTIONAL_TEXT_FIELDS = ['vehicle_type', 'customer_name', 'customer_company', 'customer_contact', 'customer_code', 'flight_number', 'notes', 'internal_notes'];
export const COUNT_FIELDS = ['passenger_count', 'luggage_count', 'infant_seat_count'];

export function mergeParsedSchedule(form, parsed) {
  parsed = { ...parsed, customer_contact: parsed.customer_contact || parsed.phone };
  const next = { ...form };
  Object.keys(form).forEach(key => {
    if (parsed[key] !== undefined && parsed[key] !== null && parsed[key] !== '') {
      next[key] = parsed[key];
    }
  });
  return next;
}

export function validateScheduleForm(form) {
  if (!form.date || !form.time || !form.pickup_location?.trim() || !form.dropoff_location?.trim()) return '日期、时间、出发地、目的地为必填项';
  for (const [field, currencyField, required] of [['price_amount', 'price_currency', true], ['driver_collection_amount', 'driver_collection_currency', false]]) {
    const value = form[field];
    if (value === '' || value == null) {
      if (required) return '请输入订单金额';
      continue;
    }
    const amount = Number(value);
    const currency = form[currencyField];
    if (!['JPY', 'CNY'].includes(currency) || !Number.isFinite(amount) || amount < 0) return '请输入有效的非负金额和币种';
    const units = amount * (currency === 'JPY' ? 1 : 100);
    if (Math.abs(units - Math.round(units)) > 0.000001) return currency === 'JPY' ? '日元金额必须为整数' : '人民币金额最多两位小数';
  }
  if (COUNT_FIELDS.some(key => form[key] !== '' && form[key] != null && (!Number.isInteger(Number(form[key])) || Number(form[key]) < 0))) return '人数和行李数量必须为非负整数';
  if (Number(form.infant_seat_count || 0) > 10) return '婴儿座椅最多10个';
  return '';
}

export async function confirmScheduleConflict(api, token, fields) {
  const response = await fetch(`${api}/dispatcher/extra-schedule/check-conflict`, {
    method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(fields),
  });
  if (!response.ok) throw new Error('无法检查排班冲突，请稍后重试');
  const data = await response.json();
  if (data.has_conflicts) {
    const details = data.conflicts.map(item => `${item.date} ${item.time} ${item.pickup_location || ''} → ${item.dropoff_location || ''}`).join('\n');
    return window.confirm(`发现时间冲突：\n${details}\n确认仍要保存此排班吗？`);
  }
  return true;
}
